
export const GET_CLIENTS = 'GET_CLIENTS';
export const GET_CLIENTS_PAGINATOR = 'GET_CLIENTS_PAGINATOR';
export const FETCH_ALL_CLIENTS = 'FETCH_ALL_CLIENTS';
export const GET_CLIENT_DETAIL = 'GET_CLIENT_DETAIL';
export const FETCH_CLIENT = 'FETCH_CLIENT';
